var _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorrowerIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#B1FF1D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4540_13484",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 30.75V8H9.25V30.75H32Z",
    fill: "white",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4540_13484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 19.375C18.1126 19.375 26.106 15.2037 31.5512 8.41103",
    stroke: "#B1FF1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67773 22.8877C10.9277 22.8535 12.1662 22.7504 13.3887 22.5805V30.3223H9.67773V22.8877Z",
    stroke: "#B1FF1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9141 21.8481C18.1764 21.5234 19.4152 21.1255 20.625 20.6571V30.3223H16.9141V21.8481Z",
    stroke: "#B1FF1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3359 18.9498C25.6195 18.2604 26.8591 17.4854 28.0469 16.6287V30.3223H24.3359V18.9498Z",
    stroke: "#B1FF1D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5723 12.1367V8.42578H27.8613",
    stroke: "#B1FF1D",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowerIcon3);
export default __webpack_public_path__ + "static/media/borrower-icon-3.5401135f915c78ebca5dd53086888249.svg";
export { ForwardRef as ReactComponent };